import React from 'react';
import ReactDOM from 'react-dom/client';
import "bootstrap/dist/css/bootstrap.min.css"
import Apps from "./apps"
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(

  
  <React.StrictMode>
  < Apps/>
  </React.StrictMode>
);
